import { Action } from 'redux';

import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { initialManageItemsTelemetry,ManageItemsTelemetry } from '../../../spaces/Collections/CollectionsTelemetry';
import { OpenManageItemsInCollectionsDialog } from '../../AppActionTypes';

export interface ManageItemsInCollectionsDialogAction extends Action {
  targetItems: IContentInfo[];
  targetCollectionLuids?: string[];
  manageItemsTelemetry: ManageItemsTelemetry;
}

export function openManageItemsInCollectionsDialogAction(
  targetItems: IContentInfo[],
  targetCollectionLuids?: string[],
  manageItemsTelemetry?: ManageItemsTelemetry
): ManageItemsInCollectionsDialogAction {
  return {
    type: OpenManageItemsInCollectionsDialog,
    targetItems,
    targetCollectionLuids,
    manageItemsTelemetry: manageItemsTelemetry || initialManageItemsTelemetry()
  };
}
